import React from 'react'

import { TradeBenefitsProps } from './types'
import {
  TradeBenefitsStyled,
  TradeBenefitsMediaStyled,
  TradeBenefitsListBoxStyled,
  TradeBenefitsListStyled,
  TradeBenefitsListItemStyled,
  TradeBenefitsIconStyled,
  TradeBenefitsLabelStyled
} from './styles'
import TradeBenefitsMedia from '../../molecules/TradeBenefitsMedia'

const TradeBenefits: React.FC<TradeBenefitsProps> = ({ data: { listItems, media, iconsList } }) => (
  <TradeBenefitsStyled>
    <TradeBenefitsMediaStyled>
      <TradeBenefitsMedia {...{ media, iconsList }} />
    </TradeBenefitsMediaStyled>
    {listItems && (
      <TradeBenefitsListBoxStyled>
        <TradeBenefitsListStyled>
          {listItems.map((item) => (
            <TradeBenefitsListItemStyled key={item.key}>
              <TradeBenefitsIconStyled />
              <TradeBenefitsLabelStyled as="p" variant="bodyMontserrat10">
                {item.label}
              </TradeBenefitsLabelStyled>
            </TradeBenefitsListItemStyled>
          ))}
        </TradeBenefitsListStyled>
      </TradeBenefitsListBoxStyled>
    )}
  </TradeBenefitsStyled>
)

export default TradeBenefits
